var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 17.5V19.5508L17.5664 19.7969L24.375 28.3008V38.5L25.7695 37.4609L29.2695 34.8359L29.625 34.5625V28.3008L36.4336 19.7969L36.625 19.5508V17.5H17.375ZM19.3711 19.25H34.6289L28.3398 27.125H25.6602L19.3711 19.25ZM26.125 27.125H27.875V33.6875L26.125 35V27.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9203 36.9794C35.9308 36.9899 35.9432 36.9983 35.9569 37.0039C35.9706 37.0096 35.9852 37.0126 36 37.0126C36.0148 37.0126 36.0295 37.0096 36.0432 37.0039C36.0569 36.9983 36.0693 36.9899 36.0797 36.9794L39.9022 33.143C40.3557 32.6852 40.6107 32.0674 40.6124 31.4231C40.614 30.7788 40.362 30.1597 39.9109 29.6996C39.6907 29.4745 39.4279 29.2956 39.1377 29.1733C38.8475 29.051 38.5359 28.9879 38.221 28.9876H38.2149C37.9011 28.9871 37.5904 29.049 37.3008 29.1698C37.0112 29.2905 36.7485 29.4677 36.528 29.6909L36 30.2207L35.4721 29.6909C35.2516 29.4677 34.9889 29.2905 34.6993 29.1698C34.4097 29.049 34.099 28.9871 33.7852 28.9876H33.779C33.4642 28.9879 33.1525 29.051 32.8624 29.1733C32.5722 29.2956 32.3093 29.4745 32.0892 29.6996C31.6381 30.1597 31.3861 30.7788 31.3877 31.4231C31.3893 32.0674 31.6444 32.6852 32.0978 33.143L35.9203 36.9794ZM32.2494 29.8577C32.4488 29.6538 32.6868 29.4917 32.9495 29.3809C33.2123 29.2701 33.4945 29.2129 33.7796 29.2126H33.7852C34.0693 29.2122 34.3507 29.2683 34.613 29.3777C34.8752 29.4871 35.1131 29.6475 35.3127 29.8497L35.9203 30.4595C35.9419 30.4799 35.9704 30.4913 36 30.4913C36.0297 30.4913 36.0582 30.4799 36.0797 30.4595L36.6873 29.8497C36.887 29.6475 37.1248 29.487 37.3871 29.3776C37.6493 29.2683 37.9307 29.2121 38.2149 29.2126H38.2204C38.5056 29.2129 38.7878 29.2701 39.0505 29.3809C39.3133 29.4917 39.5513 29.6538 39.7506 29.8577C40.1602 30.2754 40.389 30.8375 40.3875 31.4225C40.3861 32.0076 40.1545 32.5685 39.7429 32.9842L36 36.7407L32.2572 32.9842C31.8455 32.5686 31.6139 32.0076 31.6124 31.4225C31.611 30.8375 31.8398 30.2754 32.2494 29.8577Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFilter);
export default __webpack_public_path__ + "static/media/default-filter.53387683ba24b7d9a3a0f4fb0116b58d.svg";
export { ForwardRef as ReactComponent };